/**
 * Custom Mobile Navigation Toggle
 * Handles navigation toggle functionality with body class toggle
 * Simplified for custom header implementations
 */

document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('[data-nav-toggle]');
  
  if (!toggleButtons.length) return;
  
  // Add click handler to all nav-toggle buttons
  toggleButtons.forEach(toggleButton => {
    toggleButton.addEventListener('click', function() {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
      const newState = !isExpanded;
      
      // Update ARIA state for this specific button
      toggleButton.setAttribute('aria-expanded', newState.toString());
      
      // Sync ARIA state across all toggle buttons
      toggleButtons.forEach(btn => {
        if (btn !== toggleButton) {
          btn.setAttribute('aria-expanded', newState.toString());
        }
      });
      
      // Toggle aria-hidden on navigation element
      const navigation = document.querySelector('#main-navigation');
      if (navigation) {
        navigation.setAttribute('aria-hidden', (!newState).toString());
      }
      
      // Toggle menu-is-expanded class on body
      document.body.classList.toggle('menu-is-expanded', newState);
      
      // Optional: Close menu when clicking outside
      if (newState) {
        document.addEventListener('click', closeOnClickOutside);
      } else {
        document.removeEventListener('click', closeOnClickOutside);
      }
    });
  });
  
  /**
   * @param {MouseEvent} event - The click event
   */
  function closeOnClickOutside(event) {
    const target = event.target;
    
    if (!(target instanceof Node)) return;
    
    // Check if click is outside all toggle buttons
    const isOutsideAllButtons = Array.from(toggleButtons).every(button => 
      !button.contains(target)
    );
    
    if (isOutsideAllButtons) {
      // Update all toggle buttons
      toggleButtons.forEach(button => {
        button.setAttribute('aria-expanded', 'false');
      });
      
      // Close navigation
      const navigation = document.querySelector('#main-navigation');
      if (navigation) {
        navigation.setAttribute('aria-hidden', 'true');
      }
      
      document.body.classList.remove('menu-is-expanded');
      document.removeEventListener('click', closeOnClickOutside);
    }
  }
  
  // Close menu on escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      // Check if any toggle button is expanded
      const anyExpanded = Array.from(toggleButtons).some(button => 
        button.getAttribute('aria-expanded') === 'true'
      );
      
      if (anyExpanded) {
        // Close menu and update all buttons
        toggleButtons.forEach(button => {
          button.setAttribute('aria-expanded', 'false');
        });
        
        // Close navigation
        const navigation = document.querySelector('#main-navigation');
        if (navigation) {
          navigation.setAttribute('aria-hidden', 'true');
        }
        
        document.body.classList.remove('menu-is-expanded');
        
        // Focus the first visible toggle button
        const visibleButton = Array.from(toggleButtons).find(button => 
          button instanceof HTMLElement && button.offsetParent !== null
        );
        if (visibleButton instanceof HTMLElement) {
          visibleButton.focus();
        }
      }
    }
  });
});
